import { Chatbot } from '@local/chatbot';
import { FC, Fragment } from 'react';
import { Helmet } from 'react-helmet';

export const PageChatbot: FC = () => {
    return (
        <Fragment>
            <Helmet>
                <title>Support Hub Chatbot</title>
            </Helmet>
            <Chatbot />
        </Fragment>
    );
};
